import { HowTo } from '../types';

export const documentsHowTos: HowTo[] = [
  {
    key: 'documents.open-document',
    version: 1,
    section: 'Documents',
    title: 'Find and open a document',
    summary:
      "Open a child's paperwork, or a policy held for the whole organisation.",
    keywords: [
      'document', 'documents', 'file', 'files', 'pdf', 'open', 'view', 'read',
      'find', 'search', 'policy', 'policies', 'ehcp', 'report', 'paperwork',
    ],
    routes: ['/documents'],
    audience: 'staff',
    steps: [
      {
        text: 'Open **Documents** from the menu.',
        target: 'nav.documents',
        route: '/documents',
        navigateOnly: true,
      },
      {
        text: "Choose the tab: **Child documents** for one child's paperwork, **Organisation documents** for policies and anything else held for the whole setting.",
        target: 'documents.tabs',
      },
      {
        text: 'On the child tab, pick the child. The picker fills the page until one is chosen; after that, the rail on the left.',
        // The picker while it fills the page; the rail once a child is chosen.
        target: ['child-picker', 'child-rail'],
      },
      {
        text: 'Use **Search by name** or **Filter by type** to narrow a long list.',
        target: 'documents.filter',
      },
      {
        text: 'Click a document to open it in the viewer. Nothing you do in the viewer changes the file.',
        target: 'documents.list',
      },
    ],
    related: ['documents.add-document'],
  },
  {
    key: 'documents.add-document',
    version: 1,
    section: 'Documents',
    title: 'Add a document',
    summary:
      "Put a PDF on a child's record, or one held for the whole organisation — and give it a name people will recognise.",
    youNeed: [
      'The Admin role — only Admins can add or remove documents',
      'The document as a PDF',
    ],
    keywords: [
      'add', 'upload', 'new', 'attach', 'put', 'store', 'save', 'import',
      'document', 'documents', 'file', 'files', 'pdf', 'scan', 'scanned',
      'paperwork', 'policy', 'policies', 'ehcp', 'letter', 'consent', 'form',
      'report', 'rename', 'name', 'type', 'date', 'delete', 'remove',
      'permanent', 'drag', 'drop',
    ],
    routes: ['/documents'],
    audience: 'admin',
    requiredRole: 'Admin',
    steps: [
      {
        text: "Open **Documents** from the menu, then choose the tab: **Child documents** for one child's paperwork, **Organisation documents** for anything held for the whole setting.",
        target: ['documents.tabs', 'nav.documents'],
        route: '/documents',
      },
      {
        text: 'On the child tab, pick the child first. The document is filed against whoever is selected.',
        // The picker while it fills the page; the rail once a child is chosen.
        target: ['child-picker', 'child-rail'],
      },
      {
        text: 'Set the **Type** *before* you add the file: it applies to whatever you add next and nothing asks again. It starts on **Other**. Organisation documents have no type.',
        target: 'documents.upload-type',
      },
      {
        text: 'Drag the PDF onto the panel, or click **Choose PDF**. PDFs only. Several at once is fine, and they all take the type above.',
        target: 'documents.dropzone',
      },
      {
        text: 'It uploads as soon as you let go — no Save to press. The document takes its file name as its name, so that is what everyone sees.',
        target: 'documents.dropzone',
      },
      {
        text: 'The pencil, **Edit details**, sets the name, the type, a description, and the document\'s own **date** — the date on the paperwork, not the day it was uploaded. Nothing fills that in for you.',
        target: 'documents.list',
      },
      {
        text: 'The bin deletes permanently. Unlike a post there is no Recently deleted and no grace period: once confirmed, the document is gone.',
        target: 'documents.list',
      },
    ],
    related: ['documents.open-document'],
  },
];
